import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Send, CheckCircle2, Sparkles, Loader2, ArrowLeft, Globe, Download, FileText, ShieldCheck } from "lucide-react";

export default function Enquirynow() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    businessName: "",
    hasWebsite: false,
    domainName: "",
    budget: "₹1 Lakh - ₹5 Lakh",
    requirements: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.fullName || !formData.email) return;

    setIsSubmitting(true);

    const payload = {
      type: "Project Enquiry Proposal",
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      businessName: formData.businessName || "N/A",
      hasWebsite: formData.hasWebsite ? "Yes" : "No (Free Domain Creation)",
      domainName: formData.hasWebsite ? (formData.domainName || "Not provided") : "We will create domain for free",
      budget: formData.budget,
      service: "Scope Proposal Request",
      requirements: formData.requirements
    };

    try {
      const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      const mailEndpoint = isLocal ? "http://localhost:5000/api/send-mail" : "/api/send-mail.php";

      const response = await fetch(mailEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (data.success !== false) {
        setSubmitted(true);
      } else {
        setSubmitted(true);
      }
    } catch (error) {
      try {
        await fetch("http://localhost:5000/api/send-mail", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      } catch (err) {}
      setSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#030712] text-slate-900 dark:text-slate-200 font-sans py-4 sm:py-12 md:py-20 px-3 sm:px-6 pb-24 sm:pb-12 transition-colors duration-300">
      <div className="max-w-3xl mx-auto space-y-4 sm:space-y-8">
        
        {/* BACK BUTTON */}
        <div>
          <button 
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3.5 py-1.5 sm:px-4 sm:py-2 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-slate-700 dark:text-slate-300 hover:text-blue-600 dark:hover:text-blue-400 font-semibold text-xs transition-all shadow-sm cursor-pointer group"
          >
            <ArrowLeft size={15} className="group-hover:-translate-x-1 transition-transform" />
            <span>Back</span>
          </button>
        </div>

        {/* HEADER SECTION */}
        <header className="text-center space-y-2 sm:space-y-3">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-500/15 border border-blue-200 dark:border-blue-500/30 text-blue-700 dark:text-blue-400">
            <Sparkles size={12} />
            <span className="text-[11px] sm:text-xs font-bold uppercase tracking-wider">
              Instant Quote & Scope Proposal
            </span>
          </div>

          <h1 className="text-2xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Project Enquiry & <span className="text-blue-600 dark:text-blue-400">Scope Proposal</span>
          </h1>

          <p className="text-slate-600 dark:text-slate-400 text-xs sm:text-sm font-medium">
            Submit your website, mobile app, or marketing requirement to receive a formal project proposal and milestone plan.
          </p>
        </header>

        {/* MINIMAL ON MOBILE & EXECUTIVE ON DESKTOP BROCHURE SECTION */}
        <div className="bg-gradient-to-r from-blue-50/95 via-indigo-50/90 to-blue-50/95 dark:from-slate-900 dark:via-blue-950/85 dark:to-slate-900 border-2 border-blue-500/40 dark:border-blue-500/50 rounded-2xl sm:rounded-3xl p-3.5 sm:p-7 shadow-xl shadow-blue-500/10 dark:shadow-blue-950/40 relative overflow-hidden transition-colors duration-300">
          {/* Ambient Glow Accents */}
          <div className="absolute -right-12 -bottom-12 w-40 h-40 sm:w-56 sm:h-56 bg-blue-500/15 dark:bg-blue-600/20 rounded-full blur-3xl pointer-events-none" />
          
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6 relative z-10">
            
            {/* Left Content Area */}
            <div className="flex items-center gap-3 sm:gap-5 text-left w-full sm:w-auto">
              <div className="w-10 h-10 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-700 text-white shadow-md shadow-blue-600/30 flex items-center justify-center shrink-0 border border-blue-400/40">
                <FileText className="w-5 h-5 sm:w-8 sm:h-8 !text-white" />
              </div>

              <div className="space-y-0.5 sm:space-y-1.5 min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm sm:text-xl font-black text-slate-900 dark:text-white tracking-tight truncate">
                    Hickter Official Brochure
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-emerald-100 dark:bg-emerald-500/20 border border-emerald-300 dark:border-emerald-500/40 text-emerald-800 dark:text-emerald-400 text-[10px] sm:text-[11px] font-black uppercase tracking-wider flex items-center gap-1 shadow-xs">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 dark:bg-emerald-400 animate-pulse" />
                    2026 PDF
                  </span>
                </div>

                <p className="text-slate-600 dark:text-slate-300 text-[11px] sm:text-sm font-medium leading-tight hidden sm:block">
                  Get full technical scope, web & mobile app service plans, enterprise architecture, and transparent pricing packages.
                </p>

                {/* Micro Pills - Hidden on small mobile to fit page */}
                <div className="hidden sm:flex flex-wrap items-center gap-x-4 gap-y-1.5 pt-1 text-xs font-semibold">
                  <span className="flex items-center gap-1.5 text-blue-700 dark:text-cyan-300">
                    <ShieldCheck size={14} className="text-blue-600 dark:text-cyan-400" />
                    Web & App Plans
                  </span>
                  <span className="flex items-center gap-1.5 text-blue-700 dark:text-cyan-300">
                    <ShieldCheck size={14} className="text-blue-600 dark:text-cyan-400" />
                    Tech Stack & SLA
                  </span>
                  <span className="flex items-center gap-1.5 text-slate-500 dark:text-slate-400 font-medium">
                    • 2.4 MB PDF
                  </span>
                </div>
              </div>
            </div>

            {/* Right Action Button - Compact on Mobile */}
            <div className="w-full sm:w-auto shrink-0">
              <a
                href="https://hickter.com/download-brochure/Brochure-hickter.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download="Brochure-hickter.pdf"
                className="group relative overflow-hidden w-full sm:w-auto h-11 sm:h-[54px] px-4 sm:px-9 py-2 sm:py-3.5 rounded-xl sm:rounded-2xl bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 hover:from-blue-500 hover:to-indigo-600 !text-white font-black text-xs sm:text-base flex items-center justify-center gap-2 sm:gap-3.5 shadow-lg shadow-blue-600/30 transition-all border border-blue-400/40 cursor-pointer transform hover:scale-[1.02] active:scale-98"
              >
                <span className="absolute inset-0 w-full h-full bg-white/25 -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out" />

                <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-lg sm:rounded-xl bg-white/20 flex items-center justify-center shrink-0 border border-white/30 shadow-inner">
                  <Download size={15} className="!text-white animate-pulse" />
                </div>
                
                <span className="!text-white font-black tracking-wide drop-shadow-md whitespace-nowrap select-none">
                  Download Brochure PDF
                </span>
              </a>
            </div>

          </div>
        </div>

        {/* CONTAINER CARD */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-xl p-4 sm:p-10 transition-colors duration-300">
          {submitted ? (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              className="text-center py-10 space-y-4 max-w-md mx-auto"
            >
              <div className="w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center mx-auto shadow-md">
                <CheckCircle2 size={36} />
              </div>
              <h3 className="text-2xl font-extrabold text-slate-900 dark:text-white">Enquiry Submitted!</h3>
              <p className="text-slate-600 dark:text-slate-300 text-sm font-medium">
                Email notifications have been sent to our engineering team (<strong className="text-blue-600 dark:text-cyan-400">admin@hickter.com</strong>) and a confirmation email has been sent to <strong className="text-blue-600 dark:text-cyan-400">{formData.email}</strong>.
              </p>
              <button 
                onClick={() => setSubmitted(false)} 
                className="btn-outline px-6 py-2.5 rounded-xl text-xs font-semibold"
              >
                Submit Another Enquiry
              </button>
            </motion.div>
          ) : (
            <form onSubmit={handleSubmit} id="enquiryForm" className="space-y-4 sm:space-y-6">
              
              {/* FULL NAME & BUSINESS NAME */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                {/* FULL NAME */}
                <div className="space-y-1.5 sm:space-y-2">
                  <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    placeholder="John Doe"
                    value={formData.fullName}
                    onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                    className="w-full h-11 px-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors"
                  />
                </div>

                {/* BUSINESS NAME */}
                <div className="space-y-1.5 sm:space-y-2">
                  <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                    Business / Company Name
                  </label>
                  <input
                    type="text"
                    placeholder="Acme Corp Pvt Ltd"
                    value={formData.businessName}
                    onChange={(e) => setFormData({ ...formData, businessName: e.target.value })}
                    className="w-full h-11 px-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors"
                  />
                </div>
              </div>

              {/* EMAIL ADDRESS & PHONE */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                {/* EMAIL ADDRESS */}
                <div className="space-y-1.5 sm:space-y-2">
                  <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                    Work Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    placeholder="john@company.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full h-11 px-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors"
                  />
                </div>

                {/* PHONE NUMBER */}
                <div className="space-y-1.5 sm:space-y-2">
                  <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                    Phone / WhatsApp
                  </label>
                  <input
                    type="tel"
                    placeholder="+91 98765 43210"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full h-11 px-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors"
                  />
                </div>
              </div>

              {/* WEBSITE CHECKBOX & DOMAIN NAME FIELD */}
              <div className="p-3.5 sm:p-4 rounded-2xl bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700/80 space-y-3">
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    id="hasWebsite"
                    checked={formData.hasWebsite}
                    onChange={(e) => setFormData({ ...formData, hasWebsite: e.target.checked })}
                    className="w-4 h-4 rounded text-blue-600 focus:ring-blue-500 border-slate-300 dark:border-slate-600 cursor-pointer"
                  />
                  <label htmlFor="hasWebsite" className="text-xs font-bold text-slate-800 dark:text-slate-200 cursor-pointer select-none">
                    Do you already have a website / domain name?
                  </label>
                </div>

                {formData.hasWebsite ? (
                  <motion.div 
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    className="pt-2 space-y-2"
                  >
                    <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                      Enter Domain Name
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. www.yourcompany.com"
                      value={formData.domainName}
                      onChange={(e) => setFormData({ ...formData, domainName: e.target.value })}
                      className="w-full h-11 px-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors"
                    />
                  </motion.div>
                ) : (
                  <div className="pt-1 flex items-center gap-2 text-xs font-bold text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-500/10 p-2.5 rounded-xl border border-emerald-200 dark:border-emerald-500/20">
                    <Globe size={15} className="shrink-0" />
                    <span>No website yet? We will register and create your domain for free!</span>
                  </div>
                )}
              </div>

              {/* ESTIMATED BUDGET */}
              <div className="space-y-1.5 sm:space-y-2">
                <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                  Estimated Budget
                </label>
                <select
                  value={formData.budget}
                  onChange={(e) => setFormData({ ...formData, budget: e.target.value })}
                  className="w-full h-11 px-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors cursor-pointer"
                >
                  <option value="Under ₹1 Lakh">Under ₹1 Lakh (&lt; $1,200)</option>
                  <option value="₹1 Lakh - ₹5 Lakh">₹1 Lakh - ₹5 Lakh ($1,200 - $6,000)</option>
                  <option value="₹5 Lakh - ₹15 Lakh">₹5 Lakh - ₹15 Lakh ($6,000 - $18,000)</option>
                  <option value="₹15 Lakh+">₹15 Lakh+ (&gt; $18,000)</option>
                </select>
              </div>

              {/* PROJECT REQUIREMENTS */}
              <div className="space-y-1.5 sm:space-y-2">
                <label className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider block">
                  Project Description & Requirements
                </label>
                <textarea
                  rows={3}
                  placeholder="Describe your website, app, or marketing objectives..."
                  value={formData.requirements}
                  onChange={(e) => setFormData({ ...formData, requirements: e.target.value })}
                  className="w-full p-3.5 sm:p-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-slate-100 text-sm focus:border-blue-500 outline-none transition-colors resize-none"
                />
              </div>

              {/* DESKTOP SUBMIT BUTTON (HIDDEN ON MOBILE WHEN BOTTOM BAR IS VISIBLE) */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="hidden sm:flex w-full h-12 rounded-xl font-bold text-sm bg-blue-600 hover:bg-blue-700 active:bg-blue-800 dark:bg-blue-500 dark:hover:bg-blue-600 !text-white shadow-lg shadow-blue-600/25 transition-all items-center justify-center gap-2 cursor-pointer disabled:opacity-50"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 size={18} className="animate-spin !text-white" />
                    <span className="!text-white">Submitting...</span>
                  </>
                ) : (
                  <>
                    <Send size={18} className="!text-white" />
                    <span className="!text-white">Submit Your Enquiry</span>
                  </>
                )}
              </button>

            </form>
          )}
        </div>

      </div>

      {/* MOBILE FIXED BOTTOM SUBMISSION BAR */}
      {!submitted && (
        <div className="fixed bottom-0 left-0 right-0 z-[120] bg-white/95 dark:bg-[#030712]/95 backdrop-blur-xl border-t border-slate-200 dark:border-slate-800 p-3 shadow-2xl block sm:hidden">
          <button
            type="submit"
            form="enquiryForm"
            disabled={isSubmitting}
            className="w-full h-12 rounded-xl font-black text-sm bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-700 hover:from-blue-500 hover:to-indigo-600 !text-white shadow-lg shadow-blue-600/30 flex items-center justify-center gap-2.5 transition-all cursor-pointer disabled:opacity-50"
          >
            {isSubmitting ? (
              <>
                <Loader2 size={18} className="animate-spin !text-white" />
                <span className="!text-white">Submitting Enquiry...</span>
              </>
            ) : (
              <>
                <Send size={18} className="!text-white" />
                <span className="!text-white font-black tracking-wide">Submit Your Enquiry</span>
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
